<template>
  <v-container fluid>
    <PageTitle>
      Edit Text Message Configuration
    </PageTitle>
    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card class="mb-4">
        <v-card-text class="pb-0">
          <div class="d-flex align-center mb-8">
            <v-text-field :value="configuration?.registration_url"
                          label="Registration URL"
                          outlined
                          dense
                          disabled
                          hide-details
                          class="mr-1">
            </v-text-field>
            <v-btn @click.prevent="copyRegistrationURL">
              <v-icon>
                fal fa-fw fa-copy
              </v-icon>
            </v-btn>
          </div>
          <v-text-field v-model="form.code"
                        label="Code"
                        outlined
                        dense
                        clearable
                        :error-messages="form.errors.get('code')"
                        class="mb-4">
          </v-text-field>

          <v-text-field v-model="form.company_name"
                        label="Company Name"
                        outlined
                        dense
                        clearable
                        :error-messages="form.errors.get('company_name')"
                        class="mb-4">
          </v-text-field>

          <v-text-field v-model="form.message_prefix"
                        label="Message Prefix"
                        outlined
                        dense
                        clearable
                        :error-messages="form.errors.get('message_prefix')"
                        class="mb-4">
          </v-text-field>

          <v-select v-model="form.source_number"
                    label="Source Phone Number (E164)"
                    :items="numbers"
                    item-value="number.phone_number"
                    :item-text="numberText"
                    outlined
                    dense
                    clearable
                    hint="This needs to be one of the numbers in Sinch. It needs to be in E164 format."
                    :error-messages="form.errors.get('source_number')"
                    class="mb-4">
          </v-select>

          <v-select v-model="form.allowed_countries"
                    label="Allowed Countries"
                    :items="countries"
                    item-value="id"
                    item-text="name"
                    outlined
                    dense
                    multiple
                    clearable
                    :error-messages="form.errors.get('allowed_countries')"
                    class="mb-4">
          </v-select>

          <v-text-field v-model="form.privacy_policy_url"
                        label="Privacy Policy URL"
                        type="url"
                        outlined
                        dense
                        clearable
                        :error-messages="form.errors.get('privacy_policy_url')"
                        class="mb-4">
          </v-text-field>

          <v-textarea v-model="form.privacy_policy_content"
                      label="Privacy Policy Content"
                      placeholder="This is an alternative to the URL"
                      outlined
                      dense
                      clearable
                      rows="4"
                      auto-grow
                      :error-messages="form.errors.get('privacy_policy_content')"
                      class="mb-4">
          </v-textarea>

          <v-text-field v-model="form.terms_url"
                        label="Terms of Service URL"
                        type="url"
                        outlined
                        dense
                        clearable
                        :error-messages="form.errors.get('terms_url')"
                        class="mb-4">
          </v-text-field>

          <v-textarea v-model="form.terms_content"
                      label="Terms of Service Content"
                      placeholder="This is an alternative to the URL"
                      outlined
                      dense
                      clearable
                      rows="4"
                      auto-grow
                      :error-messages="form.errors.get('terms_content')">
          </v-textarea>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Update
          </v-btn>

          <v-btn :to="{name: 'admin.sinch_configurations.index'}">
            Cancel
          </v-btn>
        </v-card-actions>
        <ErrorAlert v-if="error"
                    :error="error">
        </ErrorAlert>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import PageTitle from '../../components/PageTitle.vue';
import {Form} from 'vform';
import sinchService from '../../services/sinchService';
import {mapGetters} from 'vuex';
import {isObject, isString} from 'lodash';
import ErrorAlert from '../../components/ErrorAlert.vue';
import clipboardService from '../../../../ml/services/clipboardService';

export default {
  components: {ErrorAlert, PageTitle},
  props: {
    configuration: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form(sinchService.populateForm(this.configuration)),
      countries: sinchService.getCountries(),
      error: null,
    }
  },
  computed: {
    ...mapGetters('sinch', [
      'assignedNumbers',
    ]),
    numbers() {
      return this.assignedNumbers.map(n => n);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    numberText(record) {
      if (isObject(record.assignment) && isString(record.assignment.label)) {
        return `${record.number.phone_number} | Status: ${record.number.status} | Name: ${record.assignment.label}`;
      }
      return `${record.number.phone_number} | Status: ${record.number.status}`;
    },
    async fetchData() {
      await this.$store.dispatch('sinch/fetchAssignedNumbers');
    },
    async submit() {
      if (this.form.busy) {
        return;
      }
      this.reset();
      try {
        await this.form.patch(`/api/sinch/configurations/${this.configuration.id}`)
        await this.$router.push({name: 'admin.sinch_configurations.index'});
      } catch (e) {
        this.error = e;
      } finally {
      }
    },
    reset() {
      this.error = null;
    },
    async copyRegistrationURL() {
      if (this.configuration?.registration_url) {
        try {
          await clipboardService.copy(this.configuration.registration_url);
          this.$toast.success('Registration URL copied to clipboard.');
        } catch (error) {
          this.$toast.error('Error copying registration URL to clipboard.')
        }
      }
    }
  }
}
</script>
